import { render } from "./SimulationContactCard.vue?vue&type=template&id=61f05678&scoped=true&ts=true"
import script from "./SimulationContactCard.vue?vue&type=script&lang=ts"
export * from "./SimulationContactCard.vue?vue&type=script&lang=ts"

import "./SimulationContactCard.vue?vue&type=style&index=0&id=61f05678&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f05678"]])

export default __exports__